import React from 'react';
import { useLangflow } from '../../context/LangflowContext';
import ChatModal from '../ChatModal';
import track from 'lib/track';

/**
 * LangflowChatModal - ChatModal component that automatically integrates with LangflowContext
 * This component must be used within a LangflowProvider
 */
const LangflowChatModal = ({
  isOpen,
  toggle,
  title = 'Virtual Mentor',
  onMessageSent,
  onError,
  onScore, // Add onScore prop
  suggestions = [], // Add suggestions prop
  showSuggestionsWhenEmpty = true,
  suggestionsTitle = 'Suggested prompts',
  maxSuggestions = null
}) => {
  const { messages, streamMessage, isLoading, error, clearError, currentSessionId } = useLangflow();

  const handleSend = async messageText => {
    try {
      clearError();
      track('Wellness Buddy Message Sent', { testId: 'wellness-buddy-modal' });
      await streamMessage(messageText, (chunk, fullContent) => {
        if (onMessageSent) {
          onMessageSent({ chunk, fullContent, isStreaming: true });
        }
      });
    } catch (err) {
      if (onError) {
        onError(err);
      }
    }
  };

  return (
    <ChatModal
      isOpen={isOpen}
      toggle={toggle}
      title={title}
      currentSessionId={currentSessionId} // Display session ID if available
      messages={messages}
      onSend={handleSend}
      isLoading={isLoading}
      error={error}
      onScore={onScore}
      suggestions={suggestions}
      showSuggestionsWhenEmpty={showSuggestionsWhenEmpty}
      suggestionsTitle={suggestionsTitle}
      maxSuggestions={maxSuggestions}
      footerText={
        <>
          Wellness Buddy is currently in beta, responses may take up to a minute. Answers may be inaccurate or
          incomplete. Consult your healthcare professional before making any diet or lifestyle changes. Conversations
          may be recorded for quality assurance purposes in accordance with our{' '}
          <a href="https://foodrevolution.org/privacy-policy/">Privacy Policy</a>.
        </>
      }
    />
  );
};

export default LangflowChatModal;
